import React, { Fragment, useContext } from "react";
import webTime from "../../assets/details/webinars/ic_time-webinar-blue.svg";
import webDate from "../../assets/details/webinars/ic_calendar-webinar-blue.svg";
import DetailHead from "./DetailsHead";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

const Eventwebinars = ({ myRef, eventWebinarsData }) => {
  const handleJoin = (ionWebUrl, ionId) => (e) => {
    e.preventDefault();
    window.open(
      ionWebUrl && ionId
        ? `${ionWebUrl}?${ionId}`
        : ionWebUrl
        ? `${ionWebUrl}`
        : window.location.reload()
    );
  };
  const { language } = useContext(LanguageContext);
  return (
    <Fragment>
      <section className="webinars_section">
        <div ref={myRef} className="container webinars_container">
          <DetailHead title={TEXT[language]["SUSTAINATHONS"]["12"]} />
          <div
            className="row"
            style={{
              justifyContent: "center",
            }}
          >
            {eventWebinarsData.length > 0 ? (
              eventWebinarsData.map((Webinar, index) => (
                <div
                  data-aos="zoom-in-down"
                  data-aos-duration="1000"
                  data-aos-anchor-placement="top-center"
                  className="col-lg-4 col-md-6 col-sm-12 webinar_margin"
                  key={index}
                >
                  <div className="webinar_card">
                    {Webinar.imageUrl ? (
                      <div className="webinar_image">
                        <span className="webinar_image_wrap">
                          <img
                            loading="lazy"
                            className="img-fluid webinar_main_img"
                            src={Webinar.imageUrl}
                            alt="webinarImage"
                          />
                        </span>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="webinar_content_module">
                      {Webinar.status ? (
                        <div
                          className="webinar_content_tag"
                          style={
                            Webinar.date && Webinar.time
                              ? {
                                  position: "absolute",
                                  padding: "16px",
                                }
                              : {
                                  paddingBottom: "5px",
                                }
                          }
                        >
                          <span className="webinar-tag tag-purple">
                            {Webinar.status}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="webinar_main_det">
                        {Webinar.date ? (
                          <div className="webinar_main_data webinar_date">
                            <div className="web_main_lft">
                              <img
                                className="web_icon"
                                width="15px"
                                src={webDate}
                                alt="webdate"
                              />
                            </div>
                            <div className="web_main_ryt">
                              <p className="web_main_content">{Webinar.date}</p>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {Webinar.time ? (
                          <div className="webinar_main_data webinar_time">
                            <div className="web_main_lft">
                              <img
                                className="web_icon"
                                width="15px"
                                src={webTime}
                                alt="webtime"
                              />
                            </div>
                            <div className="web_main_ryt">
                              <p className="web_main_content">{Webinar.time}</p>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="webinar_imp_det webinar_text_inner">
                        <h2>{Webinar.title}</h2>
                        <p>
                          <span>{Webinar.description}</span>
                        </p>
                      </div>
                    </div>
                    {Webinar.status !== "completed" ? (
                      <div className="sustainathon_button_module_wrapper join_button_margin sustainathon_button_alignment_center">
                        <button
                          onClick={(e) =>
                            handleJoin(Webinar.ionWebUrl, Webinar.ionId)(e)
                          }
                          className="join_btn join_color"
                        >
                          <span>{TEXT[language]["SUSTAINATHONS"]["7"]}</span>
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))
            ) : (
              <h2>{TEXT[language]["SUSTAINATHONS"]["8"]}</h2>
            )}
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Eventwebinars;
